var map = {
	"./banners/hero-bg.png": 7798,
	"./icons/avatar.png": 7406,
	"./icons/icon-email.png": 4689,
	"./icons/icon-lock.png": 7108,
	"./icons/icon-name.png": 7912,
	"./icons/icon-phone.png": 7429,
	"./icons/nav-login.png": 6258,
	"./icons/shortcut-deposit.png": 5954,
	"./icons/shortcut-referrer.png": 1087,
	"./icons/shortcut-reward.png": 3499,
	"./icons/shortcut-support.png": 1581,
	"./icons/shortcut-vip.png": 5317,
	"./icons/shortcut-withdrawal.png": 9907,
	"./icons/wallet.png": 214,
	"./menu/arcade.png": 4950,
	"./menu/bingo.png": 3897,
	"./menu/cockfight.png": 4642,
	"./menu/fish.png": 6488,
	"./menu/home.png": 5259,
	"./menu/hot.png": 1341,
	"./menu/instwin.png": 2830,
	"./menu/live.png": 5576,
	"./menu/livegrand.png": 4992,
	"./menu/lottery.png": 2555,
	"./menu/mini.png": 1559,
	"./menu/poker.png": 8435,
	"./menu/pop.png": 2737,
	"./menu/rng.png": 5099,
	"./menu/slots.png": 7719,
	"./menu/sport.png": 5370,
	"./menu/table.png": 3108,
	"./misc/logo.png": 5768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8192;